module.exports = __webpack_public_path__ + "img/구로디지털단지 쌀국수.0ce337af.png";